import React from 'react'

const Spinner = () => {
  return (
    <div className='w-full h-screen flex justify-center items-center'>
      <div className='spinner'></div>
    </div>
  )
}

export default Spinner
